/**
 * @generated SignedSource<<59321a3917562079e9c5cea3e22fac08>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type FeatureFlagProviderQuery$variables = {
  orgUuid: string;
};
export type FeatureFlagProviderQuery$data = {
  readonly organization: {
    readonly featureFlags: {
      readonly aglFromVehicleRfd: boolean;
      readonly apiObservability: boolean;
      readonly assetSettingsView: boolean;
      readonly assetSurveyFromPhotos: boolean;
      readonly atlasPointsRfdV2: boolean;
      readonly atlasPointsRfdV2MarkersOnly: boolean;
      readonly axonAlprIntegration: boolean;
      readonly brandingDfrCommand: boolean;
      readonly clearMarkersDispatchMap: boolean;
      readonly cloudRel5UiUpdates: boolean;
      readonly cloudRtkProfiles: boolean;
      readonly completeStacknavSidebar: boolean;
      readonly consumablesReport: boolean;
      readonly consumablesUsageAlerts: boolean;
      readonly consumablesV2Panel: boolean;
      readonly customMapLayersExternal: boolean;
      readonly deploymentEngineerMissionsInternal: boolean;
      readonly dfrCommand: boolean;
      readonly displayPathfinderBoundariesInMaps: boolean;
      readonly editOrgFlightPolicyR10: boolean;
      readonly enableAglGeofences: boolean;
      readonly enableAglWaypointAltitudesRfd: boolean;
      readonly enableAxonWatchMeDemo: boolean;
      readonly enableCloudTakMarkers: boolean;
      readonly enableCreateMarkerInteractionRfd: boolean;
      readonly enableCustomRfdUrl: boolean;
      readonly enableDeclarativeDockview: boolean;
      readonly enableDfrCommandPhaseThreeUi: boolean;
      readonly enableDfrCommandPhaseTwoPointFiveUi: boolean;
      readonly enableDfrCommandPhaseTwoUi: boolean;
      readonly enableDfrDockviewLayout: boolean;
      readonly enableDfrOutcomesSurvey: boolean;
      readonly enableDispatchRespondHere: boolean;
      readonly enableDockedRthDeconfliction: boolean;
      readonly enableDocklessSites: boolean;
      readonly enableFlightPathVisualization: boolean;
      readonly enableHistoricalMarkerFilters: boolean;
      readonly enableIncidentsStateUi: boolean;
      readonly enableManualClipCapture: boolean;
      readonly enableMarkerFilterSettings: boolean;
      readonly enableMulticockpitRfd: boolean;
      readonly enableMultidroneAdsbRfd: boolean;
      readonly enableMultidroneOperations: boolean;
      readonly enableMultidroneRfd: boolean;
      readonly enableNorthIndicator: boolean;
      readonly enableOperationsV0: boolean;
      readonly enableOutOfService: boolean;
      readonly enablePlannedOperations: boolean;
      readonly enablePlanningAroundGeofencesFlyToPointRfd: boolean;
      readonly enablePostFlightReports: boolean;
      readonly enableRfdDedrone: boolean;
      readonly enableRfdViewLookatPoint: boolean;
      readonly enableRfdv2SidebarLayout: boolean;
      readonly enableRfdv2SidebarStack: boolean;
      readonly enableRticMode: boolean;
      readonly enableSentryAutodetection: boolean;
      readonly enableTogglingGeofencesRfd: boolean;
      readonly enableVideoFeedbackSurvey: boolean;
      readonly fleetMapViewEnhancements: boolean;
      readonly frontendBeta: boolean;
      readonly healthStatusChangedAlert: boolean;
      readonly inmAscendFy26: boolean;
      readonly liveStreaming: boolean;
      readonly markersApi: boolean;
      readonly markersBackendFiltering: boolean;
      readonly missionsInRfdV2: boolean;
      readonly multizoneSiteGeofences: boolean;
      readonly nomadTrueOrthographicMode: boolean;
      readonly pathfinderBoundariesMenu: boolean;
      readonly playwrightBlankMapRendering: boolean;
      readonly reliableCommandeering: boolean;
      readonly rfd3dCockpit: boolean;
      readonly rfdCollapsibleSidebar: boolean;
      readonly rfdEnableRthOptimalSlider: boolean;
      readonly rfdOnSubdomain: boolean;
      readonly rfdOnSubdomainForEngineering: boolean;
      readonly rfdPinnableSidebar: boolean;
      readonly safeLandingPoints: boolean;
      readonly setupScheduledFlightsFromCloud: boolean;
      readonly shotspotterIntegration: boolean;
      readonly splitUserMediaUploadProgress: boolean;
      readonly tagSettingsView: boolean;
      readonly teleopCommandeeringV2: boolean;
      readonly usePathfinderFlyToPointRfd: boolean;
      readonly waypointDragReorder: boolean;
      readonly writeAddressForBodycams: boolean;
    } | null;
    readonly id: string;
  } | null;
};
export type FeatureFlagProviderQuery = {
  response: FeatureFlagProviderQuery$data;
  variables: FeatureFlagProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orgUuid"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "uuid",
        "variableName": "orgUuid"
      }
    ],
    "concreteType": "Organization",
    "kind": "LinkedField",
    "name": "organization",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "FeatureFlags",
        "kind": "LinkedField",
        "name": "featureFlags",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dfrCommand",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "brandingDfrCommand",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableMultidroneOperations",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableRfdDedrone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableDfrCommandPhaseTwoUi",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableDfrCommandPhaseTwoPointFiveUi",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableDfrCommandPhaseThreeUi",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableDfrDockviewLayout",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customMapLayersExternal",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableCreateMarkerInteractionRfd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableManualClipCapture",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableDocklessSites",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "multizoneSiteGeofences",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "safeLandingPoints",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableDispatchRespondHere",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "markersApi",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableIncidentsStateUi",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableAxonWatchMeDemo",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enablePostFlightReports",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cloudRel5UiUpdates",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableDfrOutcomesSurvey",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enablePlannedOperations",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "setupScheduledFlightsFromCloud",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enablePlanningAroundGeofencesFlyToPointRfd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "usePathfinderFlyToPointRfd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "apiObservability",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableRfdViewLookatPoint",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableMulticockpitRfd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableMultidroneRfd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inmAscendFy26",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "missionsInRfdV2",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assetSettingsView",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assetSurveyFromPhotos",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "axonAlprIntegration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableVideoFeedbackSurvey",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "writeAddressForBodycams",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "aglFromVehicleRfd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableAglWaypointAltitudesRfd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clearMarkersDispatchMap",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rfdOnSubdomain",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rfdOnSubdomainForEngineering",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "markersBackendFiltering",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableSentryAutodetection",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "liveStreaming",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "atlasPointsRfdV2",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableRfdv2SidebarLayout",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "playwrightBlankMapRendering",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableRfdv2SidebarStack",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nomadTrueOrthographicMode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "teleopCommandeeringV2",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "atlasPointsRfdV2MarkersOnly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deploymentEngineerMissionsInternal",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shotspotterIntegration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "consumablesReport",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "consumablesUsageAlerts",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "consumablesV2Panel",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableDeclarativeDockview",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableCustomRfdUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableRticMode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableHistoricalMarkerFilters",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableMarkerFilterSettings",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "splitUserMediaUploadProgress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "frontendBeta",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableOperationsV0",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayPathfinderBoundariesInMaps",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pathfinderBoundariesMenu",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rfdCollapsibleSidebar",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rfdPinnableSidebar",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "editOrgFlightPolicyR10",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableDockedRthDeconfliction",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rfdEnableRthOptimalSlider",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableFlightPathVisualization",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "healthStatusChangedAlert",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rfd3dCockpit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cloudRtkProfiles",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableTogglingGeofencesRfd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reliableCommandeering",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "completeStacknavSidebar",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableMultidroneAdsbRfd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "waypointDragReorder",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableNorthIndicator",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tagSettingsView",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableAglGeofences",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableCloudTakMarkers",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableOutOfService",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fleetMapViewEnhancements",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FeatureFlagProviderQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeatureFlagProviderQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2ba439706e0f67dfe697ebabf88435da",
    "id": null,
    "metadata": {},
    "name": "FeatureFlagProviderQuery",
    "operationKind": "query",
    "text": "query FeatureFlagProviderQuery(\n  $orgUuid: String!\n) @team(name: \"cloud-infrastructure\") {\n  organization(uuid: $orgUuid) {\n    id\n    featureFlags {\n      dfrCommand\n      brandingDfrCommand\n      enableMultidroneOperations\n      enableRfdDedrone\n      enableDfrCommandPhaseTwoUi\n      enableDfrCommandPhaseTwoPointFiveUi\n      enableDfrCommandPhaseThreeUi\n      enableDfrDockviewLayout\n      customMapLayersExternal\n      enableCreateMarkerInteractionRfd\n      enableManualClipCapture\n      enableDocklessSites\n      multizoneSiteGeofences\n      safeLandingPoints\n      enableDispatchRespondHere\n      markersApi\n      enableIncidentsStateUi\n      enableAxonWatchMeDemo\n      enablePostFlightReports\n      cloudRel5UiUpdates\n      enableDfrOutcomesSurvey\n      enablePlannedOperations\n      setupScheduledFlightsFromCloud\n      enablePlanningAroundGeofencesFlyToPointRfd\n      usePathfinderFlyToPointRfd\n      apiObservability\n      enableRfdViewLookatPoint\n      enableMulticockpitRfd\n      enableMultidroneRfd\n      inmAscendFy26\n      missionsInRfdV2\n      assetSettingsView\n      assetSurveyFromPhotos\n      axonAlprIntegration\n      enableVideoFeedbackSurvey\n      writeAddressForBodycams\n      aglFromVehicleRfd\n      enableAglWaypointAltitudesRfd\n      clearMarkersDispatchMap\n      rfdOnSubdomain\n      rfdOnSubdomainForEngineering\n      markersBackendFiltering\n      enableSentryAutodetection\n      liveStreaming\n      atlasPointsRfdV2\n      enableRfdv2SidebarLayout\n      playwrightBlankMapRendering\n      enableRfdv2SidebarStack\n      nomadTrueOrthographicMode\n      teleopCommandeeringV2\n      atlasPointsRfdV2MarkersOnly\n      deploymentEngineerMissionsInternal\n      shotspotterIntegration\n      consumablesReport\n      consumablesUsageAlerts\n      consumablesV2Panel\n      enableDeclarativeDockview\n      enableCustomRfdUrl\n      enableRticMode\n      enableHistoricalMarkerFilters\n      enableMarkerFilterSettings\n      splitUserMediaUploadProgress\n      frontendBeta\n      enableOperationsV0\n      displayPathfinderBoundariesInMaps\n      pathfinderBoundariesMenu\n      rfdCollapsibleSidebar\n      rfdPinnableSidebar\n      editOrgFlightPolicyR10\n      enableDockedRthDeconfliction\n      rfdEnableRthOptimalSlider\n      enableFlightPathVisualization\n      healthStatusChangedAlert\n      rfd3dCockpit\n      cloudRtkProfiles\n      enableTogglingGeofencesRfd\n      reliableCommandeering\n      completeStacknavSidebar\n      enableMultidroneAdsbRfd\n      waypointDragReorder\n      enableNorthIndicator\n      tagSettingsView\n      enableAglGeofences\n      enableCloudTakMarkers\n      enableOutOfService\n      fleetMapViewEnhancements\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1a9f2dc2be820b4a844c6a52877210b7";

export default node;
